export function getAspectRatio(isBannerImageLayout: boolean, isSmallViewport: boolean): string | undefined {
  if (!isBannerImageLayout) {
    return;
  }

  return isSmallViewport ? 'aspect-[862/148]' : 'aspect-[862/296]';
}
